import { httpPost } from "@/request/http";
import func from "@/funcs";
import {
  canInternalUserLogin,
  isInternalUser,
  normalize,
} from "@/enums/roleType";

export default {
  login(account, password) {
    return new Promise((resolve, reject) => {
      httpPost(
        "/token",
        { account, password },
        {
          meta: { skipAuthInterceptor: true },
        }
      )
        .then((data) => {
          const roleType = normalize(data.RoleType);
          if (roleType === null) {
            func.localStorage.removeAll();
            throw new Error("登入資料的角色類型無效，請聯絡系統管理員");
          }
          if (isInternalUser(roleType) && !canInternalUserLogin()) {
            func.localStorage.removeAll();
            throw new Error("內部帳號僅開放於測試與開發環境使用");
          }

          func.localStorage.set("token", data.Token);
          if (data.LoginLogId !== undefined && data.LoginLogId !== null) {
            func.localStorage.set("loginLogId", data.LoginLogId);
          } else {
            window.localStorage.removeItem("loginLogId");
          }
          func.localStorage.set("isERP", data.IsERP);
          if (data.ERPModeType !== undefined) {
            func.localStorage.set("erpModeType", data.ERPModeType);
          } else {
            window.localStorage.removeItem("erpModeType");
          }
          func.localStorage.set("isCustomer", data.IsCustomer);
          func.localStorage.set("hasOnlineOrder", data.HasOnlineOrder);
          func.localStorage.set("isFoodBySelect", data.IsFoodBySelect);
          func.localStorage.set("userId", data.UserId);
          func.localStorage.set("userName", data.UserName);
          func.localStorage.set("erpType", data.ERPType);
          func.localStorage.set("roleType", roleType);
          func.localStorage.set("productType", data.ProductType);
          func.localStorage.set("industryType", data.IndustryType);
          func.localStorage.set("hasOcard", data.HasOcard);
          func.localStorage.set("hasUberEats", data.HasUberEats);
          func.localStorage.set("hasKDSServer", data.HasKDSServer);
          func.localStorage.set(
            "hasCloudElecInvoice",
            data.HasCloudElecInvoice
          );
          func.localStorage.set("hasLineOrder", data.HasLineOrder);
          func.localStorage.set("hasPGTalk", data.HasPGTalk);
          func.localStorage.set("hasMyCard", data.HasMyCard);
          func.localStorage.set("hasPXPay", data.HasPXPay);
          func.localStorage.set("hasSurveyCake", data.HasSurveyCake);
          func.localStorage.set("hasMemberWeb", data.HasMemberWeb);
          func.localStorage.set("hasVision", data.HasVision);
          func.localStorage.set("hasBatchNumber", data.HasBatchNumber);
          func.localStorage.set("hasECPlatform", data.ECPlatformType != 0);
          func.localStorage.set("hasSpecification", data.HasSpecification);
          func.localStorage.set(
            "inventoryMachineType",
            data.InventoryMachineType
          );
          func.localStorage.set(
            "isElecInvoiceCanPreviou",
            data.IsElecInvoiceCanPrevious
          );
          func.localStorage.set("hasEnglish", data.HasEnglish);
          func.localStorage.set("hasJapanese", data.HasJapanese);
          func.localStorage.set("hasKorean", data.HasKorean);
          func.localStorage.set("hasFrench", data.HasFrench);
          func.localStorage.set("payType1", JSON.stringify(data.PayType1));
          func.localStorage.set("payType2", JSON.stringify(data.PayType2));
          func.localStorage.set("isDining", data.IsDining);
          func.localStorage.set(
            "noShowmoreSyncFoodKind",
            data.NoShowmoreSyncFoodKind
          );
          func.localStorage.set(
            "noShowmoreSyncFoodName",
            data.NoShowmoreSyncFoodName
          );
          func.localStorage.set(
            "customerDegreeName",
            JSON.stringify(data.CustomerDegreeName)
          );
          func.localStorage.set("ECPlatformType", data.ECPlatformType);
          func.localStorage.set("hasSaleOrder", data.HasSaleOrder);
          func.localStorage.set("isLabelPrint", data.IsLabelPrint);
          func.localStorage.set("hasFood", data.HasFood);
          func.localStorage.set("BusinessId", data.BlobContainerName);
          func.localStorage.set("hasDailyLimit", data.HasDailyLimit);
          func.localStorage.set("hasRoom", data.HasRoom);
          func.localStorage.set("isPasswordExpired", data.IsPasswordExpired);
          func.localStorage.set("memberCarrierType", data.MemberCarrierType);
          resolve(data);
        })
        .catch((error) => {
          const errorMessage = error?.data?.Message || error?.message;
          if (errorMessage) {
            func.message({
              type: "error",
              mainMessage: errorMessage,
            });
          } else {
            func.message({
              type: "error",
              mainMessage: "登入失敗 !",
            });
          }
          reject(error);
        });
    });
  },
  async logout() {
    const loginLogId = func.localStorage.get("loginLogId");

    try {
      if (loginLogId) {
        await httpPost(
          `/token/logout/${encodeURIComponent(loginLogId)}`,
          {},
          {
            meta: { skipUnauthorizedRedirect: true },
          }
        );
      }
    } finally {
      func.localStorage.removeAll();
    }
  },
  clearLogin() {
    func.localStorage.removeAll();
  },
};
